function exit(args) {
  return "exit";
}

export { exit };
